/* eslint-disable react/jsx-handler-names */
import React from 'react';
import differenceBy from 'lodash/differenceBy';

import { requestAnimationFrameWithFallback } from '../../utils';

export default class AnimatedFilters extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            shownFilters: props.croppedFilters,
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.expand !== this.props.expand) {
            this.updateFilters();
        }
    }

    updateFilters = () => {
        this.setState((state, props) => {
            if (props.expand) {
                // When expanding, we want to add filters one at a time, using requestAnimationFrame to
                // schedule the updates
                const difference = differenceBy(
                    props.allFilters,
                    state.shownFilters,
                    ({ value }) => value,
                );

                if (difference.length > 0) {
                    const nextShownFilters = state.shownFilters.concat(
                        difference[0],
                    );

                    requestAnimationFrameWithFallback(this.updateFilters);
                    return { shownFilters: nextShownFilters };
                }
            } else if (
                state.shownFilters.length > props.croppedFilters.length
            ) {
                // Handle collapsing, by removing one filter at a time until we reach the expected length
                let nextShownFilters = state.shownFilters.slice(
                    0,
                    state.shownFilters.length - 1,
                );

                if (
                    nextShownFilters.find(
                        ({ value }) => value === props.shownFilters,
                    )
                ) {
                    nextShownFilters.concat(
                        props.allFilters.find(
                            ({ value }) => value === props.shownFilters,
                        ),
                    );
                }

                requestAnimationFrameWithFallback(this.updateFilters);
                return { shownFilters: nextShownFilters };
            }

            return null;
        });
    };

    render() {
        let filtersToShow = this.state.shownFilters;

        if (
            !filtersToShow.find(
                ({ value }) => value === this.props.selectedFilter,
            )
        ) {
            filtersToShow = [
                ...filtersToShow,
                this.props.allFilters.find(
                    ({ value }) => value === this.props.selectedFilter,
                ),
            ];
        }

        return this.props.renderRadios(filtersToShow);
    }
}
